/*=========================================================================================
  File Name: moduleNoteActions.js
  Description: Note Module Actions
==========================================================================================*/

import noteGQL from "@/http/requests/cbs/note_gql";

export default {
	fetchNotes({ commit }, payload) {
		return new Promise((resolve, reject) => {
			noteGQL
				.getNotes(payload)
				.then(response => {
					commit("SET_NOTES", response.data);
					commit("SET_TOTAL_NOTES", response.total);
					commit("SET_IS_HAS_MORE_PAGES", response.has_more_pages);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addNote({ state, commit }, note) {
		return new Promise((resolve, reject) => {
			noteGQL
				.addNote(note)
				.then(response => {
					commit("ADD_NOTE", response);
					commit("SET_TOTAL_NOTES", state.total + 1);

					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateNote({ commit }, note) {
		return new Promise((resolve, reject) => {
			noteGQL
				.updateNote(note)
				.then(response => {
					commit("UPDATE_NOTE", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteNote({ state, commit }, noteId) {
		return new Promise((resolve, reject) => {
			noteGQL
				.deleteNote(noteId)
				.then(response => {
					commit("DELETE_NOTE", noteId);
					commit("SET_TOTAL_NOTES", state.total - 1);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	}
};
